import { log } from '../log';

export class ApplicationNotEnabledError extends Error {
  constructor(realm: string, resourceName: string) {
    super(`The application ${resourceName} is not enabled for the organisation ${realm}.`);
  }
}

export class KeycloakInitializationFailedError extends Error {
  constructor(keycloakError: unknown) {
    super('Failed to initialize keycloak client.');
    log.error('Error returned by Keycloak adapter:', keycloakError);
  }
}
